import React from 'react';
import ChoiceModal from '../ChoiceModal';
import { Button } from '@mui/material';

const ConfirmNavigation = ({ open, onLeave, onClose }) => {
	return (
		<ChoiceModal
			show={open}
			onClose={onClose}
			title="Unsaved Changes – Leave Without Saving?"
			text="You’ve made changes that haven’t been saved. If you leave now, your progress will be lost."
			actions={
				<>
					<Button color="primary" variant="contained" size="large" onClick={onLeave} autoFocus>
						Leave Anyway
					</Button>
					<Button color="secondary" variant="contained" size="large" onClick={onClose}>
						Continue Editing
					</Button>
				</>
			}
		/>
	);
};

export default ConfirmNavigation;
